export default __webpack_public_path__ + "static/clearout_favicon-d80e5ec62e99c7c8f8dcd0c669a99818.ico";